/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReportTab200ResponseProductsInnerAllOfComboProductsInner } from './GetReportTab200ResponseProductsInnerAllOfComboProductsInner';
import {
    GetReportTab200ResponseProductsInnerAllOfComboProductsInnerFromJSON,
    GetReportTab200ResponseProductsInnerAllOfComboProductsInnerFromJSONTyped,
    GetReportTab200ResponseProductsInnerAllOfComboProductsInnerToJSON,
    GetReportTab200ResponseProductsInnerAllOfComboProductsInnerToJSONTyped,
} from './GetReportTab200ResponseProductsInnerAllOfComboProductsInner';
import type { GetReportTab200ResponseProductsInnerAllOfDiscount } from './GetReportTab200ResponseProductsInnerAllOfDiscount';
import {
    GetReportTab200ResponseProductsInnerAllOfDiscountFromJSON,
    GetReportTab200ResponseProductsInnerAllOfDiscountFromJSONTyped,
    GetReportTab200ResponseProductsInnerAllOfDiscountToJSON,
    GetReportTab200ResponseProductsInnerAllOfDiscountToJSONTyped,
} from './GetReportTab200ResponseProductsInnerAllOfDiscount';
import type { GetReportTab200ResponseProductsInnerAllOfModifiersInner } from './GetReportTab200ResponseProductsInnerAllOfModifiersInner';
import {
    GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSON,
    GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSONTyped,
    GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSON,
    GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSONTyped,
} from './GetReportTab200ResponseProductsInnerAllOfModifiersInner';

/**
 * 
 * @export
 * @interface GetReportTab200ResponseProductsInner
 */
export interface GetReportTab200ResponseProductsInner {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseProductsInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseProductsInner
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseProductsInner
     */
    price: number;
    /**
     * 
     * @type {GetReportTab200ResponseProductsInnerAllOfDiscount}
     * @memberof GetReportTab200ResponseProductsInner
     */
    discount?: GetReportTab200ResponseProductsInnerAllOfDiscount;
    /**
     * 
     * @type {Array<GetReportTab200ResponseProductsInnerAllOfModifiersInner>}
     * @memberof GetReportTab200ResponseProductsInner
     */
    modifiers?: Array<GetReportTab200ResponseProductsInnerAllOfModifiersInner>;
    /**
     * 
     * @type {Array<GetReportTab200ResponseProductsInnerAllOfComboProductsInner>}
     * @memberof GetReportTab200ResponseProductsInner
     */
    comboProducts?: Array<GetReportTab200ResponseProductsInnerAllOfComboProductsInner>;
}

/**
 * Check if a given object implements the GetReportTab200ResponseProductsInner interface.
 */
export function instanceOfGetReportTab200ResponseProductsInner(value: object): value is GetReportTab200ResponseProductsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseProductsInnerFromJSON(json: any): GetReportTab200ResponseProductsInner {
    return GetReportTab200ResponseProductsInnerFromJSONTyped(json, false);
}

export function GetReportTab200ResponseProductsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseProductsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'quantity': json['quantity'],
        'price': json['price'],
        'discount': json['discount'] == null ? undefined : GetReportTab200ResponseProductsInnerAllOfDiscountFromJSON(json['discount']),
        'modifiers': json['modifiers'] == null ? undefined : ((json['modifiers'] as Array<any>).map(GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSON)),
        'comboProducts': json['comboProducts'] == null ? undefined : ((json['comboProducts'] as Array<any>).map(GetReportTab200ResponseProductsInnerAllOfComboProductsInnerFromJSON)),
    };
}

export function GetReportTab200ResponseProductsInnerToJSON(json: any): GetReportTab200ResponseProductsInner {
    return GetReportTab200ResponseProductsInnerToJSONTyped(json, false);
}

export function GetReportTab200ResponseProductsInnerToJSONTyped(value?: GetReportTab200ResponseProductsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'quantity': value['quantity'],
        'price': value['price'],
        'discount': GetReportTab200ResponseProductsInnerAllOfDiscountToJSON(value['discount']),
        'modifiers': value['modifiers'] == null ? undefined : ((value['modifiers'] as Array<any>).map(GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSON)),
        'comboProducts': value['comboProducts'] == null ? undefined : ((value['comboProducts'] as Array<any>).map(GetReportTab200ResponseProductsInnerAllOfComboProductsInnerToJSON)),
    };
}

